<template>
  <div>
    <el-form ref="form" :model="formData" :rules="rules">
      <el-table
        :data="formData.tableList"
        border
        highlight-current-row
        header-row-class-name="table-header"
        size="medium"
      >
        <el-table-column
          label="序号"
          prop="index"
          align="center"
          type="index"
          width="60"
        />
        <el-table-column label="" align="center" min-width="200">
          <template slot="header">
            <span v-if="!readOnly" class="text-danger">*</span>
            <span>议价供应商</span>
          </template>
          <template slot-scope="{ row, $index }">
            <span v-if="readOnly">{{ row.supplierName || '-' }}</span>
            <el-form-item
              v-else
              :prop="'tableList.' + $index + '.supplierId'"
              :rules="rules.supplierId"
              class="m-t-18"
            >
              <el-select v-model="row.supplierId">
                <el-option
                  v-for="item in supplierList"
                  :key="item.supplierId"
                  :label="item.supplierName"
                  :value="item.supplierId"
                />
              </el-select>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column label="议价金额" align="center" min-width="200">
          <template slot="header">
            <span v-if="!readOnly" class="text-danger">*</span>
            <span>议价金额</span>
          </template>
          <template slot-scope="{ row, $index }">
            <span v-if="readOnly">{{ row.bargainAmount ? strToThousands(row.bargainAmount) : '-' }}元</span>
            <el-form-item
              v-else
              :prop="'tableList.' + $index + '.bargainAmount'"
              :rules="rules.bargainAmount"
              class="m-t-18"
            >
              <el-input-number
                v-model.trim="row.bargainAmount"
                class="left-input-number"
                style="width: 200px"
                :min="0"
                :max="999999999.99"
                :controls="false"
                :precision="2"
                placeholder="议价金额"
              />
              <span style="display: inline-block; margin-left: 1rem;">
                元
              </span>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column label="线下议价记录" align="center" min-width="200">
          <template slot="header">
            <div>
              <span v-if="!readOnly" class="text-danger">*</span>
              <span>线下议价记录</span>
            </div>
            <div v-if="!readOnly" class="important-tip">
              支持pdf/doc/docx/xls/xlsx/ppt/pptx类型文件上传，word类型文件单个最大50MB；其他类型文件单个最大200MB；最多上传10个。
            </div>
          </template>
          <template slot-scope="{ row, $index }">
            <upload
              v-if="readOnly"
              ref="uploadFile2"
              :file-id-before="row.bargainFileIds"
              :props-data="{
                disabled: true,
                uploadMode: 'fileId',
              }"
            />
            <el-form-item
              v-else
              :prop="'tableList.' + $index + '.bargainFileIds'"
              :rules="rules.bargainFileIds"
              class="m-t-18"
            >
              <upload
                ref="uploadFile1"
                :file-id-before.sync="row.bargainFileIds"
                :props-data="{
                  uploadMode: 'fileId',
                  limit: 10
                }"
              >
                <span slot="tip"></span>
              </upload>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column
          v-if="!readOnly"
          :key="readOnly"
          label="操作"
          align="center"
          width="150"
        >
          <template slot-scope="scope">
            <el-button
              type="text"
              size="medium"
              class="text-danger"
              @click="handleDelete(scope.$index)"
            >
              移除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-form>
    <div
      v-if="!readOnly"
      class="table-btn flex-center m-t-16"
      @click="addSuppliers"
    >
      <i class="el-icon-plus"></i>
      添加供应商
    </div>
  </div>
</template>
<script>
import Upload from '@/components/common/Upload'
import { cloneDeep, isEqual } from 'lodash'

import { strToThousands } from '@/utils/utils'

export default {
  components: { Upload },

  model: {
    prop: 'list',
    event: 'change'
  },

  props: {
    list: {
      type: Array,
      default: () => []
    },

    supplierList: {
      type: Array,
      default: () => []
    },

    readOnly: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      formData: {
        tableList: []
      },
      rules: {
        supplierId: [
          { required: true, message: '请选择议价供应商', trigger: 'blur' }
        ],
        bargainAmount: [
          { required: true, message: '请输入议价金额', trigger: 'change' },
          {
            validator: (rule, value, callback) => {
              if (Number(value) <= 0) {
                callback(new Error('议价金额需大于0元'))
              }
              callback()
            },
            trigger: ['blur', 'change']
          }
        ],
        bargainFileIds: [
          { required: true, message: '请上传线下议价记录', trigger: 'change' }
        ]
      }
    }
  },

  watch: {
    list: {
      handler: function(val) {
        this.formData.tableList = cloneDeep(val)
      },
      immediate: true,
      deep: true,
    },

    'formData.tableList': {
      handler: function(val) {
        if (!isEqual(val, this.list)) {
          this.$emit('change', val)
        }
      },
      deep: true,
    }
  },

  methods: {
    strToThousands,
    /**
     * 新增供应商
     */
    addSuppliers() {
      const _supplier = {
        supplierId: '',
        supplierName: '',
        bargainAmount: '',
        bargainFileIds: []
      }
      this.formData.tableList.push(_supplier)
    },
    /**
     * @description: 删除供应商
     * @param {*}
     * @return {*}
     */
    handleDelete(index) {
      this.formData.tableList.splice(index, 1)
    },

    /**
     * 校验表格
     */
    validateTable() {
      return new Promise((resolve, reject) => {
        this.$refs.form.validate(valid => {
          if (!valid) {
            reject(new Error('请按要求填写表格'))
            return
          }

          resolve(valid)
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.table-btn {
  height: 32px;
  border: 1px dashed $primary-color;
  color: $primary-color;
  font-size: 14px;
  cursor: pointer;
  width: 100%;
  margin: 0 auto;
  background-color: $white-background-color;
  border-radius: 4px;

  i {
    @include text-bold;
    font-size: 14px;
    margin-right: 4px;
  }

  &:hover {
    opacity: 0.8;
  }
}

::v-deep .el-input-number {
  &.left-input-number {
    .el-input__inner {
      text-align: left;
    }
    input::placeholder {
      text-align: left !important;
    }
  }
}
</style>
